import { useState } from 'react';

function parseFraction(str) {
  if (!str || str.toString().trim() === '') return '';
  const s = str.toString().trim();
  const decimal = parseFloat(s);
  if (!isNaN(decimal) && !s.includes('/')) return decimal;
  const wholeAndFrac = s.split(' ');
  if (wholeAndFrac.length === 2) {
    const whole = parseFloat(wholeAndFrac[0]);
    const parts = wholeAndFrac[1].split('/');
    if (parts.length === 2) {
      const num = parseFloat(parts[0]);
      const den = parseFloat(parts[1]);
      if (!isNaN(whole) && !isNaN(num) && !isNaN(den) && den !== 0) {
        return whole + num / den;
      }
    }
  }
  const fracOnly = s.split('/');
  if (fracOnly.length === 2) {
    const num = parseFloat(fracOnly[0]);
    const den = parseFloat(fracOnly[1]);
    if (!isNaN(num) && !isNaN(den) && den !== 0) {
      return num / den;
    }
  }
  return '';
}

function toFractionString(value) {
  if (value === '' || value === null || value === undefined) return '';
  const num = parseFloat(value);
  if (isNaN(num)) return '';
  const whole = Math.floor(num);
  const decimal = num - whole;
  const fractions = [
    { val: 0.125,  str: '1/8' },
    { val: 0.25,   str: '1/4' },
    { val: 0.375,  str: '3/8' },
    { val: 0.5,    str: '1/2' },
    { val: 0.625,  str: '5/8' },
    { val: 0.6875, str: '11/16' },
    { val: 0.75,   str: '3/4' },
    { val: 0.8125, str: '13/16' },
    { val: 0.875,  str: '7/8' },
    { val: 0.9375, str: '15/16' },
  ];
  const match = fractions.find(f => Math.abs(f.val - decimal) < 0.001);
  if (decimal === 0) return `${whole}`;
  if (match) return whole === 0 ? match.str : `${whole} ${match.str}`;
  return num.toString();
}

export default function FractionInput({ value, onChange, placeholder, className }) {
  const [display, setDisplay] = useState(toFractionString(value));
  const [focused, setFocused] = useState(false);

  function handleChange(e) {
    setDisplay(e.target.value);
  }

  function handleBlur() {
    setFocused(false);
    const parsed = parseFraction(display);
    if (parsed !== '') {
      onChange(parsed);
      setDisplay(toFractionString(parsed));
    } else {
      onChange('');
      setDisplay('');
    }
  }

  function handleFocus() {
    setFocused(true);
    if (value !== '') {
      setDisplay(toFractionString(value));
    }
  }

  return (
    <input
      type="text"
      value={focused ? display : toFractionString(value)}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      placeholder={placeholder || '0'}
      className={className || 'w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-amber-700'}
    />
  );
}